import { gql } from 'graphql-tag'

export const GENERATE_QUOTE_DOCUMENT = gql`
  mutation GenerateQuoteDocument($transactionUuid: String!, $documentType: DocumentType!) {
    generateQuoteDocument(transactionUUID: $transactionUuid, documentType: $documentType) {
      documentPath
      downloadLink {
        expiresAt
        url
      }
    }
  }
`

export const GENERATE_POLICY_DOCUMENT = gql`
  mutation Mutation($policyId: String!, $documentType: DocumentType!) {
    generatePolicyDocument(policyId: $policyId, documentType: $documentType) {
      documentPath
      downloadLink {
        expiresAt
        url
      }
    }
  }
`

export const DOCUMENT_DOWNLOAD_LINK = gql`
  query DocumentDownloadLink($documentPath: String!) {
    documentDownloadLink(documentPath: $documentPath) {
      expiresAt
      url
    }
  }
`
